import { render, staticRenderFns } from "./edit-num-orders.vue?vue&type=template&id=488fa34c&"
import script from "./edit-num-orders.vue?vue&type=script&lang=js&"
export * from "./edit-num-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports